import { makeAutoObservable, runInAction } from 'mobx';
import { showToast } from '../../../utils/toast';
import { EIDR_INITIAL } from '../constants/onboard.constant';
import { EIDRURL } from '../api/url';
import { handleFetch } from '../../../utils/handleFetch';

class EIDRStore {
	EIDRData = EIDR_INITIAL;
	isEIDRChanged = false;

	constructor() {
		makeAutoObservable(this);
	}

	getEIDR = async () => {
		return await handleFetch({
			url: EIDRURL,
			method: 'GET',
			onSuccess: (data) => runInAction(() => (this.EIDRData = { ...EIDR_INITIAL, ...data })),
		});
	};

	saveEIDR = async () => {
		return showToast.promise(
			(async () => {
				const success = await handleFetch({
					url: EIDRURL,
					method: 'PUT',
					body: this.EIDRData,
					onSuccess: (data) => {
						runInAction(() => {
							this.EIDRData = data;
							this.isEIDRChanged = false;
						});
					},
				});
				if (!success) throw new Error('Failed to save EIDR');
				return success;
			})(),
			{
				loading: 'Saving EIDR...',
				success: 'EIDR saved successfully!',
				error: 'Failed to save EIDR',
			},
		);
	};

	handleChangeEIDR = (key, type, value) => {
		this.EIDRData[key][type] = value;
		this.isEIDRChanged = true;
	};
}

export const eidrStore = new EIDRStore();
